import $i18n from 'panda-i18n';
import React, { useContext } from 'react';
import { CnEllipsis } from '@/components/cn-ellipsis';
import { calcSize, canUseImageViewer } from './utils';
import { StaticFileIcon } from './icons';
import { CnIcon } from '@/components/cn-icon';
import { CnImageViewer } from '@/components/cn-image-viewer';
import { useShowDownload } from '@/components/upload-core/hooks/use-show-download';
import { UploadStateContext } from '@/components/upload-core/context';
import { useShowRemove } from '@/components/upload-core/hooks/use-show-remove';
import { useShowPreview } from '@/components/upload-core/hooks/use-show-preview';
import { CnProgress } from '@/components/cn-progress';
import { useOnRemove } from '@/components/upload-core/hooks/use-on-remove';
import './index.scss';
export const UploadListItem = (props) => {
    const { readOnly, onPreview: _onPreview, onDownload, getFileFromCache, } = useContext(UploadStateContext);
    const onRemove = useOnRemove();
    const { file } = props;
    const { status, size } = file;
    const showRemove = useShowRemove(file);
    const showDownload = useShowDownload(file);
    const showPreview = useShowPreview(file);
    const onPreview = (_file) => {
        if (_onPreview) {
            _onPreview(_file);
            return;
        }
        const src = _file.objectUrl || _file.url;
        if (canUseImageViewer(_file)) {
            CnImageViewer.open({ src });
            return;
        }
        if (src)
            window.open(src);
    };
    return (React.createElement("div", { className: "cn-oss-upload-list-item" },
        React.createElement("div", { className: "cn-oss-upload-list-item-wrapper" },
            React.createElement("div", { className: "cn-oss-upload-list-item-content", onClick: () => {
                    if (!showPreview)
                        return;
                    onPreview(getFileFromCache(file));
                } },
                React.createElement("div", { className: "cn-oss-upload-list-item-file-ext" },
                    React.createElement(StaticFileIcon, { file: file })),
                React.createElement("div", { className: "cn-oss-upload-list-item-info" },
                    React.createElement(CnEllipsis, { className: "cn-oss-upload-list-item-info-name", ellipsisPosition: "middle", endCharCount: 4, hasTooltip: false }, file.name),
                    size ? (React.createElement("div", { className: "cn-oss-upload-list-item-info-size" },
                        "(",
                        calcSize(size),
                        ")")) : null)),
            showRemove ? (React.createElement("div", { className: "cn-oss-upload-list-item-actions" },
                React.createElement("div", { onClick: () => onRemove(file), className: "cn-oss-upload-list-item-actions-item" },
                    React.createElement(CnIcon, { type: "close", size: "small" })))) : null,
            showDownload ? (React.createElement("div", { className: "cn-oss-upload-list-item-actions" },
                React.createElement("div", { onClick: (event) => {
                        event.stopPropagation();
                        if (onDownload)
                            onDownload(file);
                        else
                            window.open(file.downloadUrl || file.url);
                    }, className: "cn-oss-upload-list-item-actions-item" },
                    React.createElement(CnIcon, { type: "download", size: "small" })))) : null),
        !readOnly && status === 'error' ? (React.createElement("div", { className: "cn-oss-upload-list-item-error" }, file.errorMsg ||
            $i18n.get({
                id: 'UploadFailed',
                dm: '上传失败',
                ns: 'CnOssUpload',
            }))) : null,
        !readOnly && status === 'uploading' ? (React.createElement("div", { className: "cn-oss-upload-list-item-progress" },
            React.createElement(CnProgress, { percent: file.percent || 0, textRender: () => null }))) : null));
};
